import { render, staticRenderFns } from "./v-accordion.vue?vue&type=template&id=db3f4264&scoped=true&"
import script from "./v-accordion.vue?vue&type=script&lang=js&"
export * from "./v-accordion.vue?vue&type=script&lang=js&"
import style0 from "./v-accordion.vue?vue&type=style&index=0&id=db3f4264&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3f4264",
  null
  
)

export default component.exports